import { forwardRef } from 'react'
import cn from 'classnames/bind'

import styles from './dropdown-input.module.scss'

const cx = cn.bind(styles)

type DropdownInputProps = {
  id: string

  value: string

  placeholder?: string

  disabled?: boolean

  opened: boolean

  activeDescendant?: string

  className?: string

  error?: boolean

  onFocus: React.FocusEventHandler<HTMLInputElement>

  onBlur: React.FocusEventHandler<HTMLInputElement>

  onChange: React.ChangeEventHandler<HTMLInputElement>

  onKeyDown: React.KeyboardEventHandler<HTMLInputElement>

  onToggle: () => void

  onClear?: () => void
}

export const DropdownInput = forwardRef<HTMLInputElement, DropdownInputProps>(
  (
    {
      id,
      value,
      placeholder,
      disabled,
      opened,
      activeDescendant,
      className,
      error = false,
      onFocus,
      onBlur,
      onChange,
      onKeyDown,
      onToggle,
      onClear,
    },
    ref,
  ) => {
    const hasClearButton = !(disabled || !onClear)

    return (
      <div className={cx(styles.root, { error }, className)}>
        <input
          ref={ref}
          type="text"
          role="combobox"
          className={styles.input}
          autoComplete="off"
          spellCheck={false}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          aria-autocomplete="list"
          aria-expanded={opened}
          aria-controls={`${id}-list`}
          aria-activedescendant={activeDescendant}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />

        <button
          type="button"
          tabIndex={-1}
          onClick={onToggle}
          disabled={disabled}
          className={styles.openButton}
        >
          <div className={cx(styles.arrow, { flip: opened })} />
        </button>

        {hasClearButton && (
          <button type="button" onClick={onClear} className={styles.clearButton}>
            {'×'}
          </button>
        )}
      </div>
    )
  },
)

DropdownInput.displayName = 'DropdownInput'
